import { createSlice } from '@reduxjs/toolkit';

const initialUiState = {
	selectedProperty: 'Active Consents',
	filter: 'Last 24 hours',
  fips: []
};

const uiSlice = createSlice({
	name: 'ui',
	initialState: initialUiState,
	reducers: {
		changeSelectedProperty(state, action) {
			state.selectedProperty = action.payload;
		},
		changeFilter(state, action) {
			state.filter = action.payload;
		},
    updateFips(state,action){
      state.fips = action.payload
    }
	},
});

export const uiActions = uiSlice.actions;

export default uiSlice.reducer;
